export const environment = {
    environment: 'development',
    apiUrl: 'https://nmafsm-api-dev.azure.chevron.com/api/',
    calSettings: {
        "autoSignIn": true,
        "popupForLogin": false,
        "cacheLocation": "localStorage",
        "instance": "https://login.microsoftonline.com/",
        "tenantId": "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
        "clientId": "b293ef6b-a77e-4098-8a10-10af037d7e3c",
        "redirectUri": "https://nmafsm-dev.azure.chevron.com/",
        "oidcScopes": [
            "openid",
            "profile",
            "email",
            "offline_access"
        ],
        // API access scopes
        "apiScopes": [
            "openid",
            "profile",
            "email",
            "offline_access",
            "https://nmafsm-test.azure.chevron.com/user_impersonation"
        ],
        "graphScopes": [],
    }
};

